import { createApp } from 'vue'
import Kuvvet from './Kuvvet.vue'
import './assets/global.css'

createApp(Kuvvet).mount('#kuvvet')
